/**
 * Stufen der Bezahlschranke (Kim, 13.09.2026). Die Zahlen kommen vom Backend
 * (tarife.py) mit dem Nutzerprofil. Die Werte hier greifen nur, solange ein
 * altes, gespeichertes Profil sie noch nicht traegt -- die Pruefung beim Laden
 * (AuthContext) holt sie nach.
 */
import type { User } from '../contexts/AuthContext'

export interface Grenzen {
  /** Titel in Top-Ideen und Screener; null = alle */
  ideen: number | null
  /** Titel in der Watchlist; null = unbegrenzt */
  watchlist: number | null
  /** Eigene Linsen- und Filterkombinationen im Screener */
  eigene_filter: boolean
}

const KOSTENLOS: Grenzen = { ideen: 10, watchlist: 20, eigene_filter: false }
const UNBEGRENZT: Grenzen = { ideen: null, watchlist: null, eigene_filter: true }

export function grenzenVon(user: User | null): Grenzen {
  if (user?.grenzen) return user.grenzen
  return user?.is_pro ? UNBEGRENZT : KOSTENLOS
}

/**
 * Solange kein Zahlungsanbieter angebunden ist, vergibt Kim Pro von Hand
 * (jobs.pro_konto) -- angefragt per E-Mail an die Kontaktadresse.
 */
